/**
 * @param {ProductVariantCollection} variant
 * @returns {string|string|*}
 */
const getOptionValueProductVariantUtil = (variant) => {
  const optionValue = variant?.option_value
  if (!optionValue) {
    return
  }

  if (/default title/gi.test(optionValue)) {
    return
  }

  return optionValue
}

export default getOptionValueProductVariantUtil
